import React from "react";
import { L10n } from "@fidget/common/i18n";
import { enStrings } from "@fidget/common/i18n/locales/en";
import PaperEnvelope from "../../../assets/paper_envelope.png";
import { AgentButton } from "@fidget/common/components/inputs/buttons/agentButton/agentButton";
import styles from "./upgradePlan.css";

export enum PlanType {
  ACCELERATE = "accelerate",
  ENTERPRISE = "enterprise"
}

const ACCELERATE_DESCRIPTION: Array<keyof typeof enStrings> = [
  "upgradePlan.accelerate.contacts",
  "upgradePlan.accelerate.calls",
  "upgradePlan.accelerate.screensharing",
  "upgradePlan.accelerate.history",
  "upgradePlan.accelerate.storage"
];

const ENTERPRISE_DESCRIPTION: Array<keyof typeof enStrings> = [
  "upgradePlan.accelerate.contacts",
  "upgradePlan.accelerate.calls",
  "upgradePlan.accelerate.screensharing",
  "upgradePlan.accelerate.history",
  "upgradePlan.accelerate.storage",
  "upgradePlan.enterprise.mlAutomation",
  "upgradePlan.enterprise.sdk",
  "upgradePlan.enterprise.onboarding",
  "upgradePlan.enterprise.mlSupport"
];

export const PLAN_DESCRIPTIONS = {
  [PlanType.ACCELERATE]: ACCELERATE_DESCRIPTION,
  [PlanType.ENTERPRISE]: ENTERPRISE_DESCRIPTION
};

interface Props {
  plan: PlanType;
  closeModal: () => void;
}

interface State {
  displayMode: "default" | "messageSent";
}

export class UpgradeToPlanAgent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      displayMode: "default"
    };
  }

  sendMessageToAdmin = () => {
    // TODO: really send this message
    this.setState({ displayMode: "messageSent" });
  };

  renderDescription = () => (
    <>
      <h2 className={styles.title}>
        <L10n id={"upgradePlan.askForUpgrade"} />
      </h2>
      <div className={styles.content}>
        <p>
          <L10n id={"upgradePlan.accelerate.pleaseUpgrade"} />
        </p>
        <ul>
          {PLAN_DESCRIPTIONS[this.props.plan].map((item) => (
            <li key={item}>
              <L10n id={item} />
            </li>
          ))}
        </ul>
        <div className={styles.pushdown}>
          <AgentButton fullWidth buttonStyle={"big orange"} onClick={this.sendMessageToAdmin}>
            <L10n id={"upgradePlan.sendToMyAdmin"} />
          </AgentButton>
        </div>
      </div>
    </>
  );

  renderMessageSent = () => (
    <>
      <h2 className={styles.title}>
        <L10n id={"upgradePlan.messageSent"} />
      </h2>
      <img src={PaperEnvelope} className={styles.envelope} />
      <div className={styles.pushdown}>
        <p>
          <L10n id={"upgradePlan.findCopyOfMessage"} />
        </p>
        <AgentButton fullWidth buttonStyle={"big orange outlined"} onClick={this.props.closeModal}>
          <L10n id={"upgradePlan.close"} />
        </AgentButton>
      </div>
    </>
  );

  render() {
    switch (this.state.displayMode) {
      case "messageSent":
        return this.renderMessageSent();
      default:
        return this.renderDescription();
    }
  }
}
